<template>
  <div class="analytics-webview" style="display: flex; flex-direction: column; gap: 0px;">

    <div class="multiple-filter">

      <div class="flex-container grid grid-nogutter">
        <div class="col">
          <div class="grid grid-nogutter filter-items align-items-center h-full ">
            <div class="w-full">
                <Fieldset class="hidden-legend">
                    <div class="grid grid-nogutter filter-items-grouped">
                        <div class="col-5">
                            <Dropdown v-model="quickDatesSelected" :options="quickDates" optionLabel="label"
                              :placeholder="$t('filter_option_lastQuickTime')"
                              class="flex-item-spec-analytics" @update:modelValue="changeQuickDates"/>
                        </div>
                        <div class="col-7">
                        <Calendar class="flex-item-spec-analytics" v-model="dateInput" :showButtonBar="false" :showTime="calendarShowTime"
                            :minDate="minDateValue" :maxDate="maxDateValue" :manualInput="false" dateFormat="dd/mm/yy"
                            selectionMode="range" :showIcon="false" :placeholder="$t('appliances_table_header_registrationDate')"  @focus="focusCalendar"/>
                        </div>
                    </div>
                </Fieldset>
            </div>
            <div v-if="kpiSection && kpiFiltersSingle.length>0" 
                  v-for="(filter, i) in kpiFiltersSingle" :key="'kpiFiltersSingle_'+i"
                  class=" w-full"
                  >
                <Dropdown v-model="filter.selected_value" :options="filter.filter_values" optionLabel="desc"
                  :placeholder="getFilterName(filter.filter_key)"
                  filter class="flex-item-spec-analytics ">

                  <template #value="slotProps">
                      <div v-if="slotProps.value">
                          <span
                              :class="[{ 'fi': filter.filter_key === 'country' }, { ['fi-' + slotProps.value.code.toLowerCase()]: filter.filter_key === 'country' }]"></span>
                          {{ slotProps.value.desc }}
                      </div>
                      <span v-else>
                          {{ slotProps.placeholder }}
                      </span>
                  </template>
                  <template #option="slotProps">
                      <span
                          :class="[{ 'fi': filter.filter_key === 'country' }, { ['fi-' + slotProps.option.code.toLowerCase()]: filter.filter_key === 'country' }]"></span>
                      {{ slotProps.option.desc }}
                  </template>
                </Dropdown>
              </div>
              <div v-if="kpiSection && kpiFiltersGouped.length>0" 
                  class="col-12">
                  <Fieldset class="hidden-legend">
                      <div class="grid grid-nogutter filter-items-grouped">
                        <div class="col-12 lg:col-6 xl:col-4"
                            v-for="(filter, i) in kpiFiltersGouped" :key="'kpiFiltersGouped_'+i"
                            >
                          <Dropdown v-model="filter.selected_value" :options="filter.filter_values" optionLabel="desc"
                            :placeholder="getFilterName(filter.filter_key)"
                            filter class="flex-item-spec-analytics">

                            <template #value="slotProps">
                                <div v-if="slotProps.value">
                                    <span
                                        :class="[{ 'fi': filter.filter_key === 'country' }, { ['fi-' + slotProps.value.code.toLowerCase()]: filter.filter_key === 'country' }]"></span>
                                    {{ slotProps.value.desc }}
                                </div>
                                <span v-else>
                                    {{ slotProps.placeholder }}
                                </span>
                            </template>
                            <template #option="slotProps">
                                <span
                                    :class="[{ 'fi': filter.filter_key === 'country' }, { ['fi-' + slotProps.option.code.toLowerCase()]: filter.filter_key === 'country' }]"></span>
                                {{ slotProps.option.desc }}
                            </template>
                          </Dropdown>
                        </div>
                        <div class="col-12 lg:col-12 xl:col-4"
                            v-if="statusFilterShow === true"
                            >
                            <InputText class="flex-item-spec-analytics flex-item-spec-analytics-input-text" type="text"
                              v-model="searchStatus" :placeholder="$t('filter_placeholder_search')"></InputText>
                        </div>
                      </div>
                  </Fieldset>
              </div>
          </div>
        </div>
        <div class="col-fixed align-items-center justify-content-center flex" style="width: 200px">
          <div v-if="kpiSection" class="filters-list-new">
            <Button icon="pi pi-search appliance-search-button" @click="manageFilters()" :label="$t('filter_button_apply')" />
            <Button class="cancel-button" icon="pi pi-times appliance-search-button" @click="clearFiltersValues()"
              :label="$t('filter_button_clear')" />
          </div>
        </div>
        <div style="align-items: center;">
          <Dialog :draggable="false" v-model:visible="visible" modal :header="$t('dialog_error_header')">
            <p>{{this.$t("dialog_error_content_missingEndDate")}}</p>
          </Dialog>
        </div>
      </div>

    </div>

    <Accordion @tab-click="setKpis" v-if="kpiSection" :multiple="true" v-model:activeIndex="activeAccordions"
      class="mt-3">
      <AccordionTab v-for="accordion in kpiSection.accordions_kpi" :key="accordion.id" :header="$t('analytics_accordions_'+accordion.id)">
        <div class="grid-container">
          <div class="grid-item" v-for="kpi in accordion.kpis" :key="kpi.id">
            <div class="grid-data">
              <div class="header-chart">
                <div class="header-title">{{ $t(kpi.id+"_name") }}</div>
                <div class="header-subtitle">{{ $t(kpi.id+"_subtitle") }}</div>
              </div>
              <div v-if="kpi.loaded">
                <div class="nodata-item" v-if="kpi.chart_series === null && kpi.value === null">
                  <!-- No data -->
                  <p>{{ kpi.desc }}</p>
                </div>
                <div v-else-if="kpi.type_chart == 'stats' && kpi.value !== null" class="stats-chart">
                  <!-- No chart only value -->
                  <p>{{ kpi.value }}</p>
                </div>
                <div v-else class="chart-pie">
                  <!-- With chart -->
                  <apexchart v-if="kpi.chart_series !== null" :options="kpi.chart_options" :series="kpi.chart_series"
                    :type="kpi.type_chart"></apexchart>
                </div>
              </div>
              <div v-else class="body-chart-skeleton">
                <Skeleton width="100%" height="29vh"></Skeleton>
              </div>
            </div>
          </div>
        </div>
      </AccordionTab>
    </Accordion>

  </div>
</template>

<script>
import LoginService from "../service/LoginService";
import AnalyticsService from "../service/AnalyticsService";
import { useAnalyticsStore } from "../stores/charts.js";
import { useLoginStore } from "../stores/login.js";
import { mapState, mapActions } from "pinia";
import axios from "axios";
import { loadMessages } from '../i18n'

export default {
  data() {
    return {
      loginService: null,
      accessToken: this.$route.query.accessToken,
      applianceId: this.$route.params.id,
      type: this.$route.params.type,
      tenant: "smeg",
      sectionIndex: 0,
      kpiSection: null,
      statusFilterShow: false,
      statusOperatorOptions: null,
      searchStatus: null,
      activeAccordions: [0],
      dateInput: null,
      maxDateValue: new Date(),
      // minDateValue: this.$moment(new Date()).subtract(2, "months").startOf('month').toDate(),
      minDateValue: this.$moment(new Date()).subtract(90, "days").toDate(),
      visible: false,
      quickDates: [],
      quickDatesSelected: null,
      calendarShowTime: true,
    }
  },
  computed: {
    ...mapState(useLoginStore, ["getSource"]),
    kpiFiltersSingle: function() {
      return this.kpiSection ? this.kpiSection.filters.filter(i => i.filter_key !== 'status' && i.filter_key !== 'comparator') : []
    },
    kpiFiltersGouped: function() {
      return this.kpiSection ? this.kpiSection.filters.filter(i => i.filter_key === 'status' || i.filter_key === 'comparator') : []
    }
  },
  watch: {
      '$i18n.locale': 'setupLocalization'
  },
  created() {
    this.loginService = new LoginService();
    this.analyticsService = new AnalyticsService();

    const CancelToken = axios.CancelToken;
    this.setSource(CancelToken.source());
  },
  async mounted() {
    const messages = await loadMessages(this.$i18n.locale, this.tenant);
    this.$i18n.setLocaleMessage(this.$i18n.locale, messages);
    this.setupLocalization();

    this.quickDatesSelected = this.quickDates[3];
    this.dateInput = this.quickDates[3].value;

    if(this.$moment(this.minDateValue).isBefore(this.$moment('2024-09-03'))) {
        this.minDateValue = this.$moment('2024-09-03').toDate();
    }

    // console.log("route", this.$route);
    this.loginService.abacOnTenant(this.accessToken, this.tenant).then((response) => {
      this.kpiSection = response.role_def.analytics.sections[this.sectionIndex];
      this.doMagicStuffOnFilters();
      // this.populateCharts(0)
    });
  },
  beforeUnmount() {
    this.kpiSection = null;
  },
  methods: {
    ...mapActions(useAnalyticsStore, ["getBarChartOptions", "getPieChartOptions", "getLineChartOptions"]),
    ...mapActions(useLoginStore, ["setSource"]),
    doMagicStuffOnFilters() {
      this.kpiSection.filters.forEach(filter => filter.selected_value = null);

      const hasStatus = this.kpiSection.filters.some(obj => obj.filter_key === 'status');
      const hasComparator = this.kpiSection.filters.some(obj => obj.filter_key === 'comparator');
      // if has status then must have comparator as well
      if (hasStatus) {
          this.statusFilterShow = true;
          const filter_obj = {
              filter_desc: "comparator",
              filter_key: "comparator",
              filter_values: [
                  { code: "equals", desc: "equals" },
                  { code: "not_equals", desc: "not equals" }
              ],
              selected_value: null
          }
          this.statusFilterComparator = filter_obj;
          if (!hasComparator) {
              this.kpiSection.filters.push(filter_obj);
          }
      }

      this.kpiSection.accordions_kpi.forEach(
          (acc) => (acc.called = false)
      );

      if (this.kpiSection.accordions_kpi) {
          this.activeAccordions.forEach(activeAcc => {
              this.populateCharts(activeAcc);
          });
      }

    },
    manageFilters() {
      this.cancelSource();
      var dosearch = false;

      if (this.dateInput && this.dateInput[0] && this.dateInput[1]) {
        dosearch = true;
      } else {
        this.visible = true;
      }
      if (dosearch) {
        this.kpiSection.accordions_kpi.forEach(
          (acc) => (acc.called = false)
        );
        if (this.kpiSection.accordions_kpi) {
          this.activeAccordions.forEach(activeAcc => {
            this.populateCharts(activeAcc);
          });
        }
      }
    },
    
    changeQuickDates() {
        this.dateInput = this.quickDatesSelected.value;
        // this.calendarShowTime = true;
    },

    focusCalendar() {
        this.quickDatesSelected = null;
        // this.calendarShowTime = false;
    },

    clearFiltersValues() {
      this.cancelSource();
      this.quickDatesSelected = this.quickDates[3];
      this.dateInput = this.quickDates[3].value;
      this.kpiSection?.filters.forEach(filter => { filter.selected_value = null });
      this.searchStatus = null;
      this.manageFilters();
    },
    setKpis(event) {
      let activeAccordionsKpis =
        this.kpiSection.accordions_kpi[event.index];
      if (!activeAccordionsKpis.called) {
        this.populateCharts(event.index);
      }
    },
    populateCharts(indexAcc) {
      let accordionTabKpis = this.kpiSection.accordions_kpi[indexAcc];

      this.kpiSection.accordions_kpi[indexAcc].called = true;

      accordionTabKpis.kpis.forEach((kpi, indexKpi) => {
        this.kpiSection.accordions_kpi[indexAcc].kpis[indexKpi].loaded = false;

        let filtersReq = [];
        // console.log("FILTERS: ", JSON.stringify(this.kpiSection.filters));

        let statusFilter = {
            field: null,
            value: this.searchStatus,
            operator: null
        };

        this.kpiSection.filters.forEach(filter => {
            if (filter.selected_value && filter.filter_key !== "status" && filter.filter_key !== "comparator") {
                let operator = filter.filter_key === "status.applianceDataModelId" ? filter.filter_desc : "equals";
                let filterreq = {
                    "field": filter.filter_key,
                    "value": filter.selected_value.code,
                    "operator": operator
                };
                filtersReq.push(filterreq);
            } else if (filter.selected_value && filter.filter_key === "status") {
                // console.log("filter status: ", JSON.stringify(filter));
                statusFilter.field = filter.selected_value.code;
            } else if (filter.selected_value && filter.filter_key === "comparator") {
                // console.log("filter comparator: ", JSON.stringify(filter));
                statusFilter.operator = filter.selected_value.code;
            }
        });

        if(statusFilter.field && statusFilter.operator && statusFilter.value!=null) {
            filtersReq.push(statusFilter);
        }

        // console.log("statusFilter: ", JSON.stringify(statusFilter));
        // console.log("filtersReq: ", JSON.stringify(filtersReq));

        // let start_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[0]).startOf('day').toDate());
        // let end_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[1]).endOf('day').toDate());
        // if(this.quickDatesSelected) {
        //     start_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[0]).toDate());
        //     end_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[1]).toDate());
        // }
        let start_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[0]).toDate());
        let end_utc = this.$functions.convertDateToUTC(this.$moment(this.dateInput[1]).toDate());

        let reqChart = {
            kpi: kpi.id,
            startDate: start_utc.getTime(),
            endDate: end_utc.getTime(),
            filters: filtersReq
        };

        this.getChartById(
          reqChart,
          indexAcc,
          indexKpi
        );
      });
    },
    getChartById(reqChart, indexAccordion, indexKpi) {
      const MISSING_DATA = this.$t("error_missingData");
      this.analyticsService
        .getChartByKPIOnTenant(this.accessToken, reqChart, this.tenant)
        .then((chart) => {
          let kpi = this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi];
          if (chart.x?.length > 0 && chart.y?.length > 0) {
            let typeChart = kpi.type_chart_name;
            if (typeChart == "stats") {
              kpi.value = chart.y[0];
            } else if (typeChart == "bar") {
              kpi.chart_options = this.getBarChartOptions(chart);
              kpi.chart_series = [{ name: "Occurrences", data: chart.y }];
            } else if (typeChart == "pie") {
              kpi.chart_options = this.getPieChartOptions(chart);
              kpi.chart_series = chart.y;
            } else if (typeChart == "line") {
              kpi.chart_options = this.getLineChartOptions(chart);
              let lineSeries = [
                {
                  name: "",
                  data: chart.y,
                },
              ];
              kpi.chart_series = lineSeries;
            }
            /* ------------LINECHART-STEPLINE-------------*/
            else if (typeChart == "linechart-stepline") {
              let lineOptions = this.getLineChartOptions(chart);
              lineOptions.xaxis = { categories: chart.x, type: "datetime" };
              lineOptions.stroke = { curve: 'stepline', width: 5 };
              kpi.chart_options = lineOptions;

              let lineSeries = [
                {
                  name: "",
                  data: chart.y,
                },
              ];
              kpi.chart_series = lineSeries;
            }
            /* ------------2 LINE-------------*/
            else if (typeChart == "2-multiline") {
              let lineOptions = this.getLineChartOptions(chart);
              lineOptions.xaxis = { categories: chart.x, type: "datetime" };
              lineOptions.stroke = { width: 5 };
              kpi.chart_options = lineOptions;

              let lineSeries = [
                {
                  name: "",
                  data: chart.y[0],
                },
                {
                  name: "",
                  data: chart.y[1],
                }
              ];
              kpi.chart_series = lineSeries;
            }
            kpi.loaded = true;

          } else {
            // kpi.type_chart == null;
            kpi.desc = MISSING_DATA;
            kpi.loaded = true;
            kpi.chart_series = null;
            kpi.value = null;
          }
        })
        .catch((error) => {
          console.error("EXCEPTION " + error);
          // this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].type_chart == null;
          this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].desc = MISSING_DATA;
          this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].loaded = true;
          this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].chart_series = null;
          this.kpiSection.accordions_kpi[indexAccordion].kpis[indexKpi].value = null;
        });
    },
    cancelSource() {
      this.getSource.cancel('Operation canceled by the user.');
      // console.log("FETCH CANCELED");
      const CancelToken = axios.CancelToken;
      this.setSource(CancelToken.source());
    },
    getFilterName(key){
      switch (key) {
        case "country":
          return this.$t('filter_placeholder_country');
        case "commercialCode":
            return this.$t('filter_placeholder_model');
        case "status.applianceDataModelId":
            return this.$t('filter_placeholder_subCategory');
        case "status":
          return this.$t('filter_placeholder_status');
        case "comparator":
          return this.$t('filter_placeholder_comparator');
      }
    },
    setupLocalization(){
      this.quickDates = [{
              label: this.$t('filter_option_lastQuickTime_1h'),
              value: [this.$moment().subtract(1, "hours").toDate(), new Date()]
          },
          {
              label: this.$t('filter_option_lastQuickTime_24h'),
              value: [this.$moment().subtract(1, "days").toDate(), new Date()]
          },
          {
              label: this.$t('filter_option_lastQuickTime_48h'),
              value: [this.$moment().subtract(2, "days").toDate(), new Date()]
          },
          {
              label: this.$t('filter_option_lastQuickTime_7d'),
              value: [this.$moment().subtract(7, "days").toDate(), new Date()]
          },
          {
              label: this.$t('filter_option_lastQuickTime_30d'),
              value: [this.$moment().subtract(30, "days").toDate(), new Date()]
          },
          {
              label: this.$t('filter_option_lastQuickTime_90d'),
              value: [this.$moment().subtract(90, "days").toDate(), new Date()]
          }
      ];
      if (this.kpiSection) {
        this.kpiSection.filters = this.kpiSection.filters.map(item =>
          item.filter_key === "comparator" ? 
          {
            filter_desc: this.$t("filter_placeholder_comparator"),
            filter_key: "comparator",
            filter_values: [
              { code: "equals", desc: this.$t("filter_placeholder_comparatorEquals") },
              { code: "not_equals", desc: this.$t("filter_placeholder_comparatorNotEquals") }
            ],
            selected_value: null
          }
          : item
        );
      }
    }
  }
}
</script>
